import { buildGrantUrl } from 'components/nylas/v3/grant/helpers';
import { scopesFor } from 'components/nylas/v3/grant/scopes';

import type { ProviderName } from 'components/nylas/v3/types';
import type { SendEmailConfig } from './types';

// Round-tripped through Nylas as the OAuth `state` so the callback can return the broker to this
// contact and reopen the compose modal. Parsed server-side against /\Acompose_email:(\d+)\z/.
export function composeReturnState(contactId: number): string {
  return `compose_email:${contactId}`;
}

export function buildReauthUrl(authPath: string, provider: ProviderName, contactId: number): URL {
  return buildGrantUrl(authPath, provider, scopesFor(provider, true), composeReturnState(contactId));
}

// True when the page was reached via the post-reauth redirect and the mailbox can now send.
export function shouldAutoOpenCompose(search: string, sendEmail?: SendEmailConfig): boolean {
  if (!sendEmail?.enabled || !sendEmail.canSend || !sendEmail.path) return false;

  return new URLSearchParams(search).get('compose_email') === '1';
}
